import {ReactElement} from 'react';
import * as ReactDOM from 'react-dom';
import {printCss} from './printCss';

export const showPrintPopup = <P extends {}>(title: string, content: ReactElement<P>) => {
  const win = window.open('', '_blank');
  if (win) {
    win.document.title = title;

    // CSS
    const style: HTMLStyleElement = win.document.createElement('style');
    style.textContent = printCss;
    const head = win.document.querySelector('head');
    if (head) {
      head.appendChild(style);
    }

    const el = win.document.createElement('div');
    el.className = 'print';
    win.document.body.appendChild(el);

    ReactDOM.render(content, el);
  }
};



// WEBPACK FOOTER //
// ./src/print/PrintPopup.tsx